const API_BASE_PATH = '/api/v2';
const API_BASE_PATH_ADMIN = API_BASE_PATH + '/admin';
const API_BASE_PATH_DEMOWALLET = '/api/v2/demowallet';
const API_BASE_PATH_DEMOWALLET_ADMIN = API_BASE_PATH_DEMOWALLET + '/admin';

export { API_BASE_PATH, API_BASE_PATH_ADMIN, API_BASE_PATH_DEMOWALLET, API_BASE_PATH_DEMOWALLET_ADMIN };
